import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./notification-badge.css?inline";

@customElement("eko-notification-badge")
class NotificationBadge extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ type: Number, reflect: true })
  count?: number;

  @property({ reflect: true })
  theme?: "danger" | "warning" | "success" | "info";

  @property({ reflect: true })
  variant?: "plain";

  render() {
    if (!this.count || this.count <= 0) {
      return nothing;
    }

    const displayText = this.count > 99 ? "99+" : this.count.toString();

    return html`<span class="eko-notification-badge">${displayText}</span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-notification-badge": NotificationBadge;
  }
}

export default NotificationBadge;
